export default "__VITE_ASSET__CZT2g1UL__"